import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MeasureServiceConfig } from './measure-service.types';

export function provideMeasureService(config: MeasureServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'measureServiceConfig', useValue: config }
  ]);
}
